import { get } from "@/application/api";
import { AxiosResponse } from "axios";

export interface ProfileResponse {
  data: {
    id: number;
    email: string;
    objectionRequestIds: number[];
  };
}

export const profile = (): Promise<AxiosResponse<ProfileResponse>> => {
  return get("profile");
};
